import {createContext} from "use-context-selector";
import React from "react";
import {useAppContextState} from "app/@hooks";


const Context = createContext({})

const initialState = {
    eventsData: [], isOpenEventPopover: false, monthAlerts: {},
    isOpenAlertsDrawer: false, isOpenFormModal: false, eventToEdit: {},
    formData: {
        idEvent: null, dateRange: [], relevance: '1', title: null,
        description: null, dateType: '1Day', datePicker: null
    }
}

export function AppCalendarEventsProvider({children}) {

    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context